import React from "react";

interface SimpleButtonProps {
  text: string;
  colour: string;
  type?: "button" | "submit" | "reset";
  onClick?: () => void;
  disabled?: boolean;
  className?: string;
}

export default function SimpleButton({
  text,
  colour,
  type = "button",
  onClick,
  disabled = false,
  className = "",
}: SimpleButtonProps) {
  const colourMap: Record<string, string> = {
    orange: "bg-orange border-orange hover:brightness-90",
    yellow: "bg-yellow border-yellow hover:brightness-90",
    blue: "bg-blue border-blue hover:brightness-90",
    green: "bg-mint-green border-mint-green hover:brightness-90",
    red: "bg-red-500 border-red-500 hover:bg-red-600",
  };

  return (
    <button
      type={type}
      onClick={onClick}
      disabled={disabled}
      className={`px-4 sm:px-5 py-2 sm:py-2.5 rounded-full border-2 font-bold text-white text-sm sm:text-base transition shadow-sm hover:shadow-md ${
        colourMap[colour] || colourMap.orange
      } ${disabled ? "opacity-50 cursor-not-allowed" : ""} ${className}`}
    >
      {text}
    </button>
  );
}
